<template>
  <div class="CreateProjectComponent">

    <b-form >

      <b-form-group id="input-group-Name" :label="lang.label_Name" label-for="input-2">
        <b-form-input
          id="input-Name"
          v-model="form.Name"
          :placeholder="lang.placeholder_Name"
          size="sm"
          required
          aria-describedby="input-Name-feedback"
          :state="validation_Name"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Name-feedback" :state="validation_Name">
          {{lang.validinfo_Name}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-Revision" :label="lang.label_Revision" label-for="input-2">
        <b-form-input
          id="input-Revision"
          v-model="form.Revision"
          :placeholder="lang.placeholder_Revision"
          size="sm"
          required
          aria-describedby="input-Revision-feedback"
          :state="validation_Revision"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Revision-feedback" :state="validation_Revision">
          {{lang.validinfo_Revision}}
        </b-form-invalid-feedback>
      </b-form-group>

    </b-form>
  </div>
</template>

<script>


export default {
  name: "CreateProjectComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        Name: '',
        Revision: '',
        
      },
      inputStatus: null,
      
    }
  },
  computed: {
    validation_Name() {
      
      
      if (this.form.Name.length == 0){
        return null;
      }
      return this.form.Name.length > 0
    },
    validation_Revision() {
      if (this.form.Revision.length == 0){
        return null;
      }
      return this.form.Revision.length > 0
    },
    
  },
  created() {


  },
  updated(){
    
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_createProjectForm", this.form)
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .CreateProjectComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/CreateProjectComponent.vue